module.exports = __webpack_public_path__ + "static/img/myEmbryHalf.b54f630.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/myEmbryHalf.png
// module id = B3D1
// module chunks = 5